import {redirect} from "react-router-dom";
import CowStages from "../../../services/UkTreatmentApi/CowStages";

export async function action({params}) {
    await CowStages.delete(params.cowStageId);

    return redirect("/manage/cow_stages");
}